import React from "react";
import {
  Row,
  Col,
  FormGroup,
  InputGroup,
  FormControl,
  Form,
  Card,
  Accordion,
  Alert,
} from "react-bootstrap";
import { toast } from "react-toastify";
import cx from "classnames";
import SwitchButton from "src/components/switchButton";
import LoadingMessage from "src/legacy/components/LoadingMessage";
// import "!style-loader!css-loader!src/css/react-switch-button.css";
import styles from "./hubspotConfigurationView.module.scss";
import SendButton from "src/legacy/components/SendButton";
import SlidePaneView from 'src/legacy/components/SlidePaneView';
import ButtonContainer from 'src/legacy/components/Button';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import Toast from "src/components/toast";

class HubspotConfigurationView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      primaryIntegration: _.get(this.props, "primaryIntegration") === null ? this.props.integration : this.props.primaryIntegration,
      primaryId: _.get(this.props.primaryIntegration, "id"),
      primaryCreatedBy: _.get(this.props.primaryIntegration, "createdBy") || '',
      primaryEmail: _.get(this.props.primaryIntegration, "configuration.email") || '',
      secondaryEmail: _.get(this.props, "secondaryInstance.email") || '',
      syncReadAssetEvent: _.get(this.props, "integration.configuration.syncReadAssetEvent", true),
      syncReadConversationEvent:  _.get(this.props, "integration.configuration.syncReadConversationEvent", true),
      syncReshareConversationEvent:  _.get(this.props, "integration.configuration.syncReshareConversationEvent", true),
      syncLeadCreatedEvent:  _.get(this.props, "integration.configuration.syncLeadCreatedEvent", true),
      syncAssetDownloadEvent:  _.get(this.props, "integration.configuration.syncAssetDownloadEvent", true),
      syncDeals:  _.get(this.props, "integration.configuration.syncDeals", true),
      eventId: null,
      supportCustomBehavioralEvents:  _.get(this.props, "supportCustomBehavioralEvents", false),
      adminConfiguration: _.get(this.props, "primaryIntegration") === null ? true : false,
      secondaryInstance: _.get(this.props, "primaryIntegration") === null ?  false : true,
      secondaryInstanceEvents: {},
      isAdminConfigurationEdit: false,
      isSecondaryInstanceEdit: false,
      showOverrideIntegration: _.get(this.props, "primaryIntegration") === null ? false : true,
      showSecondaryOverrideSlider: false,
      changePrimaryConfig: false,
      isEditing: false,
      updatingEventKey: false
    };

    this.populateState = this.populateState.bind(this);
    this.populatedSecondaryState = this.populatedSecondaryState.bind(this);
    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._toggleSecondaryInstance = this._toggleSecondaryInstance.bind(this);
    this.saveChanges = this.saveChanges.bind(this);
    this._handleEventIdChange = this._handleEventIdChange.bind(this);
    this._renderHeader = this._renderHeader.bind(this);
    this._renderSecondaryInstance = this._renderSecondaryInstance.bind(this);
    this._renderSecondaryInstanceEvents = this._renderSecondaryInstanceEvents.bind(this);
    this.changePrimaryConfigConfirmSlider = this.changePrimaryConfigConfirmSlider.bind(this);
    this.secondaryOverrideSlider = this.secondaryOverrideSlider.bind(this);
    this.removeSecondaryConfigSlider = this.removeSecondaryConfigSlider.bind(this);
    this.overrideSecondaryInstance = this.overrideSecondaryInstance.bind(this);
    this.handleRemoveClick = this.handleRemoveClick.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedHubspot = localizedStrings.components.integrations.hubspot;
    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedIntgerationActions = localizedStrings.components.integrations.actions;
  }

  componentDidMount() {
    this.populateState();
  }

  componentWillReceiveProps(nextProps){

    if(!_.isEqual(this.props.secondaryInstance, nextProps.secondaryInstance) && _.get(nextProps, "primaryIntegration") != null){
      const secondaryEmail =  _.get(nextProps, "secondaryInstance.email") === null ? (this.state.primaryEmail ? this.state.primaryEmail : this.state.secondaryEmail) :  _.get(nextProps, "secondaryInstance.email", '');
      this.setState({
        primaryEmail: _.get(nextProps, "primaryIntegration.configuration.email") || '',
        syncReadAssetEvent: _.get(nextProps, "primaryIntegration.configuration.syncReadAssetEvent", true),
        syncReadConversationEvent:  _.get(nextProps, "primaryIntegration.configuration.syncReadConversationEvent", true),
        syncReshareConversationEvent:  _.get(nextProps, "primaryIntegration.configuration.syncReshareConversationEvent", true),
        syncLeadCreatedEvent:  _.get(nextProps, "primaryIntegration.configuration.syncLeadCreatedEvent", true),
        syncAssetDownloadEvent:  _.get(nextProps, "primaryIntegration.configuration.syncAssetDownloadEvent", true),
        syncDeals:  _.get(nextProps, "primaryIntegration.configuration.syncDeals", true),
        secondaryEmail: secondaryEmail,
        secondaryInstanceEvents: {
          syncAssetDownloadEvent: _.get(nextProps, "secondaryInstance.syncAssetDownloadEvent", true),
          syncDeals: _.get(nextProps, "secondaryInstance.syncDeals", true),
          syncLeadCreatedEvent: _.get(nextProps, "secondaryInstance.syncLeadCreatedEvent", true),
          syncReadAssetEvent: _.get(nextProps, "secondaryInstance.syncReadAssetEvent", true),
          syncReadConversationEvent: _.get(nextProps, "secondaryInstance.syncReadConversationEvent", true),
          syncReshareConversationEvent: _.get(nextProps, "secondaryInstance.syncReshareConversationEvent", true),
        },
      })
    } 
    if(!_.isEqual(this.props.secondaryInstance, nextProps.secondaryInstance) && _.get(nextProps, "primaryIntegration") == null){
      const primaryIntegration = _.get(nextProps, "primaryIntegration") === null ? false : true;
      const secondaryEmail =  _.get(nextProps, "secondaryInstance.email") != null ? _.get(nextProps, "secondaryInstance.email") : _.get(nextProps, "primaryIntegration.configuration.email");
      const check = primaryIntegration ? _.get(nextProps, "secondaryInstance.syncAssetDownloadEvent", true) : true;

      this.setState({
        primaryEmail: _.get(nextProps, "secondaryInstance.email") || '',
        syncReadAssetEvent: _.get(nextProps, "integration.configuration.syncReadAssetEvent", true),
        syncReadConversationEvent:  _.get(nextProps, "integration.configuration.syncReadConversationEvent", true),
        syncReshareConversationEvent:  _.get(nextProps, "integration.configuration.syncReshareConversationEvent", true),
        syncLeadCreatedEvent:  _.get(nextProps, "integration.configuration.syncLeadCreatedEvent", true),
        syncAssetDownloadEvent:  _.get(nextProps, "integration.configuration.syncAssetDownloadEvent", true),
        syncDeals:  _.get(nextProps, "integration.configuration.syncDeals", true),
        secondaryEmail: secondaryEmail,
        secondaryInstanceEvents: {
          syncAssetDownloadEvent: primaryIntegration ? _.get(nextProps, "secondaryInstance.syncAssetDownloadEvent", true) : true,
          syncDeals: primaryIntegration ? _.get(nextProps, "secondaryInstance.syncDeals", true) : true,
          syncLeadCreatedEvent: primaryIntegration ?  _.get(nextProps, "secondaryInstance.syncLeadCreatedEvent", true): true,
          syncReadAssetEvent: primaryIntegration ? _.get(nextProps, "secondaryInstance.syncReadAssetEvent", true): true,
          syncReadConversationEvent: primaryIntegration ? _.get(nextProps, "secondaryInstance.syncReadConversationEvent", true): true,
          syncReshareConversationEvent:primaryIntegration ?  _.get(nextProps, "secondaryInstance.syncReshareConversationEvent", true): true,
        }
      })
    }
  }

  populateState() {
    const getConfiguration = (integration) => _.get(integration, "configuration", null);
  
    const extractIntegrationData = (integration) => {
      const configuration = getConfiguration(integration);
  
      const eventId = _.get(configuration, "customBehavioralEvents.eventId", null);
      const supportCustomBehavioralEvents = _.get(configuration, "customBehavioralEvents.supported", false);
      
      return {
        eventId,
        supportCustomBehavioralEvents,
        primaryEmail: _.get(integration, "configuration.email", null),
        syncReadAssetEvent: _.get(integration, "configuration.syncReadAssetEvent", true),
        syncReadConversationEvent: _.get(integration, "configuration.syncReadConversationEvent", true),
        syncReshareConversationEvent: _.get(integration, "configuration.syncReshareConversationEvent", true),
        syncLeadCreatedEvent: _.get(integration, "configuration.syncLeadCreatedEvent", true),
        syncDeals: _.get(integration, "configuration.syncDeals", true),
        syncAssetDownloadEvent: _.get(integration, "configuration.syncAssetDownloadEvent", true),
      };
    };
  
    const primaryIntegration = this.props.primaryIntegration;
    const integration = this.props.integration;
  
    if (primaryIntegration || integration) {
      const data = primaryIntegration ? extractIntegrationData(primaryIntegration) : extractIntegrationData(integration);
  
      this.setState(data);
    }

    this.populatedSecondaryState();
  }

  populatedSecondaryState(){
    const primaryIntegration = _.get(this.props, "primaryIntegration") === null ? false : true;
    this.setState({
      secondaryInstanceEvents: {
        syncAssetDownloadEvent: primaryIntegration ? _.get(this.props, "secondaryInstance.syncAssetDownloadEvent", true) : true,
        syncDeals: primaryIntegration ? _.get(this.props, "secondaryInstance.syncDeals", true) : true,
        syncLeadCreatedEvent: primaryIntegration ?  _.get(this.props, "secondaryInstance.syncLeadCreatedEvent", true): true,
        syncReadAssetEvent: primaryIntegration ? _.get(this.props, "secondaryInstance.syncReadAssetEvent", true): true,
        syncReadConversationEvent: primaryIntegration ? _.get(this.props, "secondaryInstance.syncReadConversationEvent", true): true,
        syncReshareConversationEvent:primaryIntegration ?  _.get(this.props, "secondaryInstance.syncReshareConversationEvent", true): true,
      }
    })
  }
  

  _toggleSwitchChange(field) {

    this.setState({
      [field]: !this.state[field],
    });
  }

  _toggleSecondaryInstance(field){

    this.setState(prevState => {
      return {
        secondaryInstanceEvents: {
          ...prevState.secondaryInstanceEvents,
          [field]: !prevState.secondaryInstanceEvents[field],
        }
      }
    });
  }

  _handleEventIdChange(e) {
    this.setState({ 
      eventId: e.target.value,
      updatingEventKey: true
     });
  }

  saveChanges() {
    let customBehavioralEvents =
      _.get(this.state, "primaryIntegration.configuration.customBehavioralEvents");

    customBehavioralEvents.eventId = this.state.eventId;

    var configuration = {
      ...this.state.primaryIntegration.configuration,
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.syncLeadCreatedEvent,
      syncDeals: this.state.syncDeals,
      syncAssetDownloadEvent: this.state.syncAssetDownloadEvent,
      customBehavioralEvents: customBehavioralEvents,
    };

    var request = {
      ...configuration,
      integrationId: _.get(this.state, "primaryIntegration.id")
    }

    this.props.updateConfiguration(request).then((response) => {
      if (!response) {
        toast(
          <Toast.Sucess
            message={this.localizedIntegrations.toast.hubspot}
          />,
          {
            autoClose: 3000,
          }
        );
      }
    }).then(() => this.props.fetchHubspotIntegration());

    this.setState({
      isEditing: false,
      isAdminConfigurationEdit: false,
      updatingEventKey: false
    })
  }

  _renderHeader(){
    var header = (
      <Row className={styles.header}>
        <Col md={8} mdOffset={1}>
        <Card>
        <div className={styles.headerContent}>
        {!this.state.adminConfiguration && !this.props.isPrimaryTokenExpired && (

         <span className={cx("paperflite-plus",styles.icon)} onClick={() => this.setState({adminConfiguration: true})}></span>

        )}
        {this.state.adminConfiguration && !this.props.isPrimaryTokenExpired && (
          <span className={cx('paperflite-', styles.indicator, styles.active)} onClick={() => this.setState({adminConfiguration: false})}></span>
        )}
        <Card.Body className={styles.CardBody}>
        <span className={styles.title}>{ this.localizedIntegrations.admin_configuration }</span> {this.props.isPrimaryTokenExpired && <i className= {cx("fa-solid fa-circle-exclamation", styles.error)} />}
        </Card.Body>
      </div>
      </Card>
      </Col>
      </Row>
    );

    return(
      <Accordion
      onClick={()=>{
        this.setState({
          adminConfiguration: !this.state.adminConfiguration
        })
      }}
      defaultKey={this.state.adminConfiguration || this.props.isPrimaryTokenExpired && '123'}
      className={styles.advanceSettings}>
    <Accordion.Item 
    eventKey="123"
    onClick={(e)=>{
      if(this.props.isPrimaryTokenExpired){
        e.preventDefault()
        return
      }
    }}
    
    >
      <Accordion.Header>{
        header
      }</Accordion.Header>
      <Accordion.Body>
          <>
      {this.props.isPrimaryTokenExpired && (
          <Row className={styles.tokenExpiry}>
            <Col md={8} mdOffset={1} className={styles.tokenExpiryContent}>
              <Alert variant="warning" className={styles.alertMessage}>{ this.localizedHubspot.error_messages.expired}
              </Alert>
            </Col>
          </Row>
          )}
  
          {!this.props.isPrimaryTokenExpired && this._renderConfig()}
          </>
      </Accordion.Body>
    </Accordion.Item>
  </Accordion>
    )
  }

  handleSecondaryInstanceSave(){
    let customBehavioralEvents = this.state.primaryIntegration.configuration.customBehavioralEvents;
    customBehavioralEvents.eventId = this.state.eventId;

    const id = _.get(this.props, "primaryIntegration") === null ? this.props.integration.id : this.props.primaryIntegration.id;

    var configuration = {
      ...this.state.primaryIntegration.configuration,
      syncReadAssetEvent: this.state.secondaryInstanceEvents.syncReadAssetEvent,
      syncReadConversationEvent: this.state.secondaryInstanceEvents.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.secondaryInstanceEvents.syncReshareConversationEvent,
      syncLeadCreatedEvent: this.state.secondaryInstanceEvents.syncLeadCreatedEvent,
      syncDeals: this.state.secondaryInstanceEvents.syncDeals,
      syncAssetDownloadEvent: this.state.secondaryInstanceEvents.syncAssetDownloadEvent,
      customBehavioralEvents: customBehavioralEvents,
    };

    this.props.overridePrimaryConfiguration(configuration, id).then((response) => {
      if (!response) {
        toast(
          <Toast.Sucess
            message={this.localizedCommons.success}
          />,
          {
            autoClose: 3000,
          }
        );
      }
      
    });

    this.setState({
      isEditing: false,
      isSecondaryInstanceEdit: false
    })
  }

  handleRemoveClick(){
    this.props.deleteSecondaryConfiguration(this.props.integration.id);
    this.setState({
      showSecondaryConfigRemoval: false
    })
  }

  changePrimaryConfigConfirmSlider(){
    return (
      <div className={styles.sliderContainer}>
        <div>
          <div className={styles.silderContent}>
            <p className={styles.title}>{ this.localizedHubspot.sliders.change_admin_config.title }</p>
            <p className={styles.description}>{ this.localizedHubspot.sliders.change_admin_config.sub_text }</p>
            <p className={styles.note}>{ this.localizedHubspot.sliders.change_admin_config.note } </p>

          </div>
          <div className={styles.sliderBody}>

          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.updating ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed}
                className={styles.updateAction}
                primary
                disabled={this.props.updating}
                onClick={() => {
                  this.props.handleOverridePrimaryInstance(_.get(this.state, "primaryIntegration.id"))
                  this.setState({
                    changePrimaryConfig: false
                  })
                }
                }
              />

              <ButtonContainer
                title={ this.localizedCommons.actions.cancel }
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ changePrimaryConfig: false })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  overrideSecondaryInstance(){
    this.props.handleOverrideSecondaryInstance(this.state.primaryIntegration.id);
    this.setState({
      showSecondaryOverrideSlider: false
    })
  }

  secondaryOverrideSlider(){
    return (
      <div className={styles.sliderContainer}>
        <div >
          <div className={styles.silderContent}>
            <p className={styles.title}>{ this.localizedHubspot.sliders.override.title }</p>
            <p className={styles.description}>{ this.localizedHubspot.sliders.override.sub_text }</p>
          </div>
          <div className={styles.sliderBody}>
          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.authenticating ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed }
                className={styles.updateAction}
                primary
                disabled={this.props.authenticating}
                onClick={() => {
                  this.overrideSecondaryInstance();
                }}
              />

              <ButtonContainer
                title={ this.localizedCommons.actions.cancel }
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ 
                  showSecondaryOverrideSlider: false, 
                  isEditing: false
                  })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  removeSecondaryConfigSlider() {
    return (
      <div className={styles.sliderContainer}>
        <div>
          <div className={styles.silderContent}>
            <p className={styles.title}>{ this.localizedHubspot.sliders.remove_secondary.title }</p>
            <p className={styles.description}>{ this.localizedHubspot.sliders.remove_secondary.sub_text }</p>

          </div>
          <div className={styles.sliderBody}>

          </div>
          <div className={styles.silderButtonContainer}>
            <ButtonContainer.Tray className={cx(styles.updateActions)}>
              <ButtonContainer
                title={this.props.deactivating ? this.localizedCommons.actions.proceeding : this.localizedCommons.actions.proceed }
                className={styles.updateAction}
                primary
                disabled={this.props.deactivating}
                onClick={this.handleRemoveClick}
              />

              <ButtonContainer
                title={ this.localizedCommons.actions.cancel }
                className={cx(styles.updateAction, styles.cancel)}
                onClick={() => this.setState({ showSecondaryConfigRemoval: false })} />

            </ButtonContainer.Tray>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className={styles.content}>
        {this.props.loading && (
          <LoadingMessage
            className={styles.loadingMessage}
            message={ this.localizedIntegrations.loading_configuration }
            visible={this.props.loading}
          />
        )}

      {this.state.showOverrideIntegration && (
        <div>
        {this._renderHeader()}
        {this._renderSecondaryInstance()}
        </div>
        
        )
      }

      {!this.props.loading && !this.state.showOverrideIntegration &&(
        <div className={styles.adminConfiguration}> 
          <span className={styles.title}>{ this.localizedIntegrations.admin_configuration }</span>
            {this._renderConfig()}
        </div>
        )}

      <SlidePaneView width={"30vw"} show={this.state.changePrimaryConfig || this.state.showSecondaryOverrideSlider || this.state.showSecondaryConfigRemoval}>
          {this.state.changePrimaryConfig && this.changePrimaryConfigConfirmSlider()}
          {this.state.showSecondaryOverrideSlider && this.secondaryOverrideSlider()}
          {this.state.showSecondaryConfigRemoval && this.removeSecondaryConfigSlider()}
      </SlidePaneView>
      
      </div>
    );
  }

  canEdit() {
    if (this.props.user.admin) {
      return true;
    } else if (this.state.primaryCreatedBy) {
      return this.state.primaryCreatedBy.id === this.props.user.id;
    }
    return false;
  }

  _renderSecondaryInstanceEvents(){
    return(
      <div>
      <FormGroup className={cx(styles.formGroup)}>
      <span className={styles.title}>{ this.localizedCommons.email }</span>
      {this.props.primaryIntegration && (
      <div className={styles.overrideDetails}>
        <span> {this.state.secondaryEmail ? this.state.secondaryEmail : this.state.primaryEmail}</span>
        <button className={styles.remove} onClick={() => this.setState({showSecondaryConfigRemoval: true})}>{ this.localizedCommons.actions.remove }</button>
      </div>
      )}
      </FormGroup>
      {this.props.primaryIntegration ? (
        <div>
        <Form.Text className={styles.subText}>{ this.localizedHubspot.active }
        </Form.Text>
        </div>
       ): (
            <Form.Text className={styles.subText}>
              {localizedStrings.formatString(this.localizedHubspot.secondary_active,
                <span className={styles.email}>{this.state.secondaryEmail ? this.state.secondaryEmail : this.state.primaryEmail}</span>,
                <span
                  onClick={() => this.setState({ showSecondaryOverrideSlider: true })}
                  className={styles.clickHere}
                >{this.localizedHubspot.error_messages.click_here} </span>
              )}
              .
            </Form.Text>
        )}
        <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.secondarySyncEvents}>
                <h5> { this.localizedIntegrations.sync_events }</h5>
                {!this.state.isSecondaryInstanceEdit && (
                <button onClick={() => this.setState({isSecondaryInstanceEdit: true, isEditing: true})}>{ this.localizedCommons.actions.edit }</button>
                )}
              </InputGroup>
            </FormGroup>
            <Form.Text>
              
              { this.localizedHubspot.config }
              
            </Form.Text>

            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  {!this.state.isSecondaryInstanceEdit && (
                    <span className={cx(
                     {[styles.on] : _.get(this.state, "secondaryInstanceEvents.syncReadAssetEvent")}
                    )}>
                      {_.get(this.state, "secondaryInstanceEvents.syncReadAssetEvent") ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}
                      </span>
                  )}
                  {this.state.isSecondaryInstanceEdit && (<SwitchButton 
                    id="syncReadAssetEvent"
                    className={styles.switch}
                    checked={_.get(this.state, "secondaryInstanceEvents.syncReadAssetEvent")}
                    handleCheck={() => this._toggleSecondaryInstance("syncReadAssetEvent")} 
                    />)}
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                {!this.state.isSecondaryInstanceEdit && (
                    <span className={cx(
                      {[styles.on] : _.get(this.state, "secondaryInstanceEvents.syncReadConversationEvent")}
                    )}>
                      { _.get(this.state, "secondaryInstanceEvents.syncReadConversationEvent") ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                  )}
                {this.state.isSecondaryInstanceEdit && (<SwitchButton 
                    id="syncReadConversationEvent"
                    className={styles.switch}
                    checked={_.get(this.state, "secondaryInstanceEvents.syncReadConversationEvent")}
                    handleCheck={() =>this._toggleSecondaryInstance("syncReadConversationEvent")} />)}
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                {!this.state.isSecondaryInstanceEdit && (
                    <span 
                    className={cx(
                      {[styles.on] : _.get(this.state, "secondaryInstanceEvents.syncReshareConversationEvent")}
                    )}>
                      {_.get(this.state, "secondaryInstanceEvents.syncReshareConversationEvent") ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}
                    </span>
                  )}
                {this.state.isSecondaryInstanceEdit && (<SwitchButton 
                    id="syncReshareConversationEvent"
                    className={styles.switch}
                    checked={_.get(this.state, "secondaryInstanceEvents.syncReshareConversationEvent")}
                    handleCheck={() => this._toggleSecondaryInstance("syncReshareConversationEvent")}
                     />)}
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>
                {!this.state.isSecondaryInstanceEdit && (
                    <span
                    className={cx(
                      {[styles.on] : _.get(this.state, "secondaryInstanceEvents.syncAssetDownloadEvent")}
                    )}>
                    {_.get(this.state, "secondaryInstanceEvents.syncAssetDownloadEvent") ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                  )}
                {this.state.isSecondaryInstanceEdit && (<SwitchButton 
                    id="syncAssetDownloadEvent"
                    className={styles.switch}
                    checked={_.get(this.state, "secondaryInstanceEvents.syncAssetDownloadEvent")}
                    handleCheck={() => this._toggleSecondaryInstance("syncAssetDownloadEvent")} 
                    />)}
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>
                {!this.state.isSecondaryInstanceEdit && (
                    <span className={cx(
                      {[styles.on] : _.get(this.state, "secondaryInstanceEvents.syncLeadCreatedEvent")}
                    )}>
                    {_.get(this.state, "secondaryInstanceEvents.syncLeadCreatedEvent") ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                  )}
                {this.state.isSecondaryInstanceEdit && (<SwitchButton 
                    id="syncLeadCreatedEvent"
                    className={styles.switch}
                    checked={_.get(this.state, "secondaryInstanceEvents.syncLeadCreatedEvent")}
                    handleCheck={() => this._toggleSecondaryInstance("syncLeadCreatedEvent")} 
                    />)}
              </div>

              <div className={styles.event}>
                <label>{ this.localizedIntegrations.sync_deals }</label>
                    <span className={styles.on}>
                    { this.localizedIntgerationActions.on }</span>
              </div>

            </FormGroup>
            
            {(_.get(this.props, "primaryIntegration") === null || this.state.isSecondaryInstanceEdit) && (
                  <div className={styles.buttonTray}>
                  <SendButton
                    className={cx(styles.save)}
                    title={this.props.updating ? `${this.localizedCommons.actions.saving}...`: this.localizedCommons.actions.save}
                    primary
                    disabled={this.props.updatingPrimaryOverrideEvents}
                    onClick={() => this.handleSecondaryInstanceSave()}
                  ></SendButton>
                  {this.state.isSecondaryInstanceEdit && (
                         <SendButton
                         title={this.localizedCommons.actions.cancel}
                         disabled={this.props.updating}
                         className={cx(styles.cancel)}
                         onClick={() => {
                           this.setState({ isSecondaryInstanceEdit: false, isEditing: false })
                         }}
                       ></SendButton>
                  )}
                </div>
            )}
      </div>
      
    )
  }

  _renderSecondaryInstance() {
    return (
      <Row className={cx(styles.row, styles.secondaryInstance)}>
        <Col md={8} mdOffset={1}
        className={styles.formContainer}>
          <div className={styles.form}>
          <span className={styles.title}>{ this.localizedIntegrations.override_configuration }</span> {this.props.isSecondaryTokenExpired && <i className= {cx("fa-solid fa-circle-exclamation", styles.error)} />}
          {this.props.isSecondaryTokenExpired && (<Alert variant="warning" className={styles.alertMessage}>
              {localizedStrings.formatString(this.localizedHubspot.error_messages.session_expired_secondary,
                <button className={styles.clickHere} onClick={() => this.overrideSecondaryInstance()}> {this.localizedHubspot.error_messages.click_here} </button>
              )}
            </Alert>)}
          {!this.props.isSecondaryTokenExpired && this._renderSecondaryInstanceEvents()}
          </div>
        </Col>
      </Row>
    )
  }

  _renderConfig() {
    return (
      <Row className={styles.row}>
        <Col md={8} mdOffset={1}>
          <div className={styles.form}>
            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{ this.localizedCommons.email }</span>
                </InputGroup.Text>
                <FormControl
                  type="text"
                  placeholder=""
                  value={this.state.primaryEmail}
                  disabled
                />
                {this.canEdit() && (<InputGroup.Text className={styles.changePrimaryConfig} onClick={() => this.setState({changePrimaryConfig: true})}>{ this.localizedCommons.actions.change }</InputGroup.Text>)}
              </InputGroup>
            </FormGroup>
            <Form.Text>
              { this.localizedHubspot.active_email }
            </Form.Text>

              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <InputGroup.Text className={styles.start}>
                    <span>{ this.localizedIntegrations.event_key }</span>
                  </InputGroup.Text>
                  <FormControl
                    type="text"
                    placeholder=""
                    value={this.state.eventId}
                    disabled = {!this.canEdit()}
                    onChange={this._handleEventIdChange}
                  />
                </InputGroup>
              </FormGroup>

            <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className={styles.adminSyncEvents}>
                <h5>{ this.localizedIntegrations.sync_events }</h5>
                {this.canEdit() && !this.state.isAdminConfigurationEdit && (<button onClick={() => this.setState({isAdminConfigurationEdit: true, isEditing: true})}>{ this.localizedCommons.actions.edit }</button>)}
              </InputGroup>
            </FormGroup>
            <Form.Text>
              { this.localizedHubspot.config }
            </Form.Text>
            <FormGroup className={cx(styles.formGroup, styles.events)}>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_asset }</label>
                {!this.state.isAdminConfigurationEdit && (
                  <span className={cx({
                    [styles.on] : this.state.syncReadAssetEvent
                  })}>
                    {this.state.syncReadAssetEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off }</span>
                )}
                {this.state.isAdminConfigurationEdit && (<SwitchButton
                  id="syncReadAssetEvent"
                  className={styles.switch}
                  checked={this.state.syncReadAssetEvent}
                  handleCheck={() => this._toggleSwitchChange("syncReadAssetEvent")}
                />)}
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.view_collection }</label>
                {!this.state.isAdminConfigurationEdit && (
                  <span className={cx({
                    [styles.on] : this.state.syncReadConversationEvent
                  })}>
                    {this.state.syncReadConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                )}
                {this.state.isAdminConfigurationEdit && (<SwitchButton
                  id="syncReadConversationEvent"
                  className={styles.switch}
                  checked={this.state.syncReadConversationEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")}
                />)}
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                {!this.state.isAdminConfigurationEdit && (
                  <span className={cx({
                    [styles.on] : this.state.syncReshareConversationEvent
                  })}>
                    {this.state.syncReshareConversationEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}
                  </span>
                )}
                {this.state.isAdminConfigurationEdit && (<SwitchButton
                  id="syncReshareConversationEvent"
                  className={styles.switch}
                  checked={this.state.syncReshareConversationEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")}
                />)}
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.download_asset }</label>
                {!this.state.isAdminConfigurationEdit && (
                  <span className={cx({
                    [styles.on] : this.state.syncAssetDownloadEvent
                  })}>
                    {this.state.syncAssetDownloadEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                )}
                {this.state.isAdminConfigurationEdit && (<SwitchButton
                  id="syncAssetDownloadEvent"
                  className={styles.switch}
                  checked={this.state.syncAssetDownloadEvent}
                  handleCheck={()=>this._toggleSwitchChange("syncAssetDownloadEvent")}
                />)}
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.create_lead }</label>
                {!this.state.isAdminConfigurationEdit && (
                  <span className={cx({
                    [styles.on] : this.state.syncLeadCreatedEvent
                  })}>
                    {this.state.syncLeadCreatedEvent ? this.localizedIntgerationActions.on : this.localizedIntgerationActions.off}</span>
                )}
                {this.state.isAdminConfigurationEdit && (<SwitchButton
                  id="syncLeadCreatedEvent"
                  className={styles.switch}
                  checked={this.state.syncLeadCreatedEvent}
                  handleCheck={() => this._toggleSwitchChange("syncLeadCreatedEvent")}
                />)}
              </div>
              <div className={styles.event}>
                <label>{ this.localizedIntegrations.configs.sync_deals }</label>
                  <span className={styles.on}>
                  { this.localizedIntgerationActions.on }</span>
              </div>
            </FormGroup>
            {!this.state.showOverrideIntegration && (
               <div className={styles.overrideConfiguration} onClick={() => this.setState({
                showOverrideIntegration : true,
                adminConfiguration: false
              })}>{ this.localizedIntegrations.override_configuration }</div>
            )}

            {(this.state.isAdminConfigurationEdit || this.state.updatingEventKey ) && (<div className={styles.buttonTray}>
              <SendButton
                className={cx(styles.save)}
                title={this.props.updating ? `${this.localizedCommons.actions.saving}...` : this.localizedCommons.actions.save}
                primary
                disabled={this.props.updating}
                onClick={this.saveChanges}
              ></SendButton>
              <SendButton
                title={this.localizedCommons.actions.cancel}
                disabled={this.props.updating}
                className={cx(styles.cancel)}
                onClick={() => {
                  this.setState({ 
                    isAdminConfigurationEdit: false, 
                    isEditing: false,
                    updatingEventKey: false,
                    eventId: "" })
                }}
              ></SendButton>
            </div>)}
          </div>
        </Col>
      </Row>
    );
  }
}

export default HubspotConfigurationView;
